// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdNotificationPreferencesUpdateResult = objectOf({
  "15": objectOf({
    email_enabled: boolean,
    webhook_enabled: nullOrUndefined,
    all_admins_subscribed: boolean,
    all_devs_subscribed: boolean,
    developer_ids: arrayOf(string),
    no_profile_emails: arrayOf(nullOrUndefined),
    webhook_endpoints: nullOrUndefined,
    target_all_app_groups: boolean,
    app_group_ids: arrayOf(nullOrUndefined),
    frequency_options: arrayOf(nullOrUndefined),
  }),
  info: string,
});
